import {
  type GetContextMenuItemsParams,
  type MenuItemDef,
} from '@ag-grid-community/core'
import {
  availableSearchItems,
  getBlockExplorer,
  getMEVAnalyticsExplorer,
  getSearchItem,
} from '../../utils/explorers'
import { generateIcon } from './generateIcon'

export function getDefaultAddressItems(
  params: GetContextMenuItemsParams,
  chain: string,
  address: string,
): Array<MenuItemDef | string> {
  if (!chain) {
    throw new Error('Chain is required')
  }

  if (!address) {
    throw new Error('Address is required')
  }

  const currentContextItems: Array<MenuItemDef | string> =
    params.defaultItems ?? []

  const { allowExternalLinks } = params.context as {
    allowExternalLinks: boolean
  }
  if (!allowExternalLinks) {
    return currentContextItems
  }

  const searchMenu = []
  try {
    const blockExplorer = getBlockExplorer(chain, address)
    searchMenu.push({
      name: `Search on ${blockExplorer.name}`,
      action: () => {
        window.open(blockExplorer.address, '_blank')
      },
    })
  } catch (e) {
    // do nothing
  }

  availableSearchItems.forEach((item) => {
    const searchItem = getSearchItem(item, address)
    if (searchItem) {
      searchMenu.push({
        name: `Search on ${searchItem.name}`,
        action: () => {
          window.open(searchItem.address, '_blank')
        },
      })
    }
  })

  try {
    const mevExplorer = getMEVAnalyticsExplorer(chain, address)
    searchMenu.push({
      name: `Search on ${mevExplorer.name}`,
      action: () => {
        window.open(mevExplorer.address, '_blank')
      },
    })
  } catch (e) {
    // do nothing
  }

  if (searchMenu.length) {
    currentContextItems.push({
      name: 'Search',
      icon: generateIcon({ icon: 'search' }),
      subMenu: searchMenu,
    })
  }

  return currentContextItems
}

export function getDefaultTransactionHashItems(
  params: GetContextMenuItemsParams,
) {
  const currentContextItems: Array<MenuItemDef | string> =
    params.defaultItems ?? []
  const data = params?.node?.data

  const { allowExternalLinks } = params.context as {
    allowExternalLinks: boolean
  }
  if (!allowExternalLinks) {
    return currentContextItems
  }

  const searchMenu = []
  try {
    const blockExplorer = getBlockExplorer(data.chain_id, params.value)
    searchMenu.push({
      name: `Search on ${blockExplorer.name}`,
      action: () => {
        window.open(blockExplorer.transaction, '_blank')
      },
    })
  } catch (e) {
    // do nothing
  }

  try {
    const mevExplorer = getMEVAnalyticsExplorer(data.chain_id, params.value)
    searchMenu.push({
      name: `Search on ${mevExplorer.name}`,
      action: () => {
        window.open(mevExplorer.transaction, '_blank')
      },
    })
  } catch (e) {
    // do nothing
  }

  if (searchMenu.length) {
    currentContextItems.push({
      name: 'Search',
      icon: generateIcon({ icon: 'search' }),
      subMenu: searchMenu,
    })
  }

  return currentContextItems
}
